import { Link as WalrusLink } from '@do/walrus';
import styled from 'styled-components';
import newBrandDesignVars from './overwrite-vars.scss';

const NewLink = styled(WalrusLink)`
  color: ${newBrandDesignVars.primary};
`;

export default NewLink;
